export const blockIconsFileCreateNewFolder = (
	<span className='material-symbols-outlined'>create_new_folder</span>
);
